import React from "react";
import PropTypes from "prop-types";

// Button that triggers a request of whatever function is passed as a prop
function RefreshButton({ dataCallbacks }) {
  function refreshData(callbacks) {
    // Allows one or more functions to be called
    if (typeof callbacks === "function") {
      callbacks();
    } else {
      callbacks.forEach((fn) => {
        fn();
      });
    }
  }

  return (
    <a
      href="#"
      style={{ marginRight: "12px" }}
      onClick={(e) => {
        e.preventDefault();
        refreshData(dataCallbacks);
      }}
    >
      <span className="fa fa-refresh"></span>
    </a>
  );
}

RefreshButton.propTypes = {
  dataCallbacks: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
};

export default RefreshButton;
